import {TrmzFile} from "@web-libs/features/files/trmz-file/domain/trmz-file.types";
import {createContext} from "react";
import {useContextStrict} from "@web-libs/core/context/context.functions";

export const TrmzFileConcernContext = createContext<TrmzFileConcern|null>(null)

export const useTrmzFile = () => {
    return useContextStrict(TrmzFileConcernContext)
}

export interface TrmzFileConcern {
    download: (trmzFile: TrmzFile) => void;
}

export const useProvideTrmzFile = ():TrmzFileConcern => {
    return {
        download: (trmzFile: TrmzFile) => {
            const fileUrl = trmzFile.fileUrl;

            const downloadLink = document.createElement('a');
            downloadLink.href = fileUrl;
            downloadLink.setAttribute('download', trmzFile.fileName);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        }
    }
}
